module.exports = require("../lib/context-reducer/index");